import { z } from 'zod';
import { fieldChangeSchema } from '#src/archive/box.contract.js';
import { permissionSchema } from '#src/auth/permissions.contract.js';
import { pageOf } from '#src/common/pagination.contract.js';
export const ROLE_NAME_MAX_LENGTH = 100;
export const ROLE_DESCRIPTION_MAX_LENGTH = 500;
/** Código de perfil (`admin`, `operador`, `consulta`). */
export const roleCodeSchema = z.string().trim().min(1).max(50);
/**
 * Perfil e o que ele permite. Os da D7 vêm das migrations; os outros, quem
 * gere acessos cria pela tela. Nenhum é apagado: é desativado.
 */
export const roleSchema = z.strictObject({
    code: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    active: z.boolean(),
    permissions: z.array(permissionSchema),
    /** Usuários ativos com o perfil: quem uma mudança alcança. */
    members: z.int().nonnegative(),
    /** Última mudança; nula enquanto vale o que veio da migration. */
    lastChange: z
        .strictObject({ at: z.iso.datetime({ offset: true }), actor: z.string() })
        .nullable(),
});
export const rolePageSchema = pageOf(roleSchema);
export const roleActionSchema = z.enum([
    'created',
    'updated',
    'deactivated',
    'reactivated',
]);
/**
 * Uma mudança no perfil. Em `changes`, `permissions` traz as chaves do
 * catálogo separadas por vírgula.
 */
export const roleHistoryEntrySchema = z.strictObject({
    action: roleActionSchema,
    at: z.iso.datetime({ offset: true }),
    actor: z.string(),
    changes: z.record(z.string(), fieldChangeSchema),
});
export const roleDetailSchema = z.strictObject({
    role: roleSchema,
    history: z.array(roleHistoryEntrySchema),
});
const nameSchema = z.string().trim().min(1).max(ROLE_NAME_MAX_LENGTH);
/**
 * Texto vazio vale como "sem descrição" (o serviço grava nulo). Sem
 * `transform` aqui: o schema vira JSON Schema na referência da API.
 */
const descriptionSchema = z
    .string()
    .trim()
    .max(ROLE_DESCRIPTION_MAX_LENGTH)
    .nullable();
/**
 * Cria um perfil. O código sai do nome (`Operador fiscal` vira
 * `operador-fiscal`) e não muda mais. As permissões precisam vir com as que
 * cada uma exige (`requires` no catálogo).
 */
export const createRoleRequestSchema = z.strictObject({
    name: nameSchema,
    description: descriptionSchema.optional(),
    permissions: z.array(permissionSchema),
});
/** Só os campos enviados mudam. `active: false` desativa. */
export const updateRoleRequestSchema = z
    .strictObject({
    name: nameSchema.optional(),
    description: descriptionSchema.optional(),
    permissions: z.array(permissionSchema).optional(),
    active: z.boolean().optional(),
})
    .refine((body) => Object.keys(body).length > 0, 'Informe ao menos um campo');
//# sourceMappingURL=role.contract.js.map